/**
 * @file Barrel export for SectionSeparator component
 * @module features/notes/components/SectionSeparator
 */

export { default } from "./SectionSeparatorView";
